import axios from "axios";

const api = axios.create({
    baseURL: "https://api.uzpfp.uz/api",
});

export default api